<template>
  <div ref="container" class="full-width full-height">
    <!-- video will be added here dynamically -->
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css' // CSS

export default {
  name: 'VideoPlayer',

  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      player: null
    }
  },

  watch: {
    options: {
      handler(newOptions, oldOptions) {
        if (newOptions !== oldOptions) {
          this.$nextTick(() => this.initPlayer())
        }
      },
      immediate: true
    }
  },

  beforeDestroy() {
    this.disposePlayer()
  },

  methods: {
    initPlayer() {
      this.disposePlayer()

      var elVideo = document.createElement('video')
      elVideo.className = 'video-js'

      this.$refs.container.appendChild(elVideo)

      this.player = videojs(elVideo, this.options)
    },

    disposePlayer() {
      if (this.player) {
        this.player.dispose()
      }
    }
  }
}
</script>
